import { queryParams, type RouteQueryOptions, type RouteDefinition, type RouteFormDefinition, applyUrlDefaults } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Reimbursements\ReimbursementsController::sign
* @see app/Http/Controllers/Reimbursements/ReimbursementsController.php:141
* @route '/api/{edition}/reimbursements/{reimbursement}/sign'
*/
export const sign = (args: { edition: string | number, reimbursement: number | { id: number } } | [edition: string | number, reimbursement: number | { id: number } ], options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: sign.url(args, options),
    method: 'post',
})

sign.definition = {
    methods: ["post"],
    url: '/api/{edition}/reimbursements/{reimbursement}/sign',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Reimbursements\ReimbursementsController::sign
* @see app/Http/Controllers/Reimbursements/ReimbursementsController.php:141
* @route '/api/{edition}/reimbursements/{reimbursement}/sign'
*/
sign.url = (args: { edition: string | number, reimbursement: number | { id: number } } | [edition: string | number, reimbursement: number | { id: number } ], options?: RouteQueryOptions) => {
    if (Array.isArray(args)) {
        args = {
            edition: args[0],
            reimbursement: args[1],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        edition: args.edition,
        reimbursement: typeof args.reimbursement === 'object'
        ? args.reimbursement.id
        : args.reimbursement,
    }

    return sign.definition.url
            .replace('{edition}', parsedArgs.edition.toString())
            .replace('{reimbursement}', parsedArgs.reimbursement.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Reimbursements\ReimbursementsController::sign
* @see app/Http/Controllers/Reimbursements/ReimbursementsController.php:141
* @route '/api/{edition}/reimbursements/{reimbursement}/sign'
*/
sign.post = (args: { edition: string | number, reimbursement: number | { id: number } } | [edition: string | number, reimbursement: number | { id: number } ], options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: sign.url(args, options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Reimbursements\ReimbursementsController::sign
* @see app/Http/Controllers/Reimbursements/ReimbursementsController.php:141
* @route '/api/{edition}/reimbursements/{reimbursement}/sign'
*/
const signForm = (args: { edition: string | number, reimbursement: number | { id: number } } | [edition: string | number, reimbursement: number | { id: number } ], options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: sign.url(args, options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Reimbursements\ReimbursementsController::sign
* @see app/Http/Controllers/Reimbursements/ReimbursementsController.php:141
* @route '/api/{edition}/reimbursements/{reimbursement}/sign'
*/
signForm.post = (args: { edition: string | number, reimbursement: number | { id: number } } | [edition: string | number, reimbursement: number | { id: number } ], options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: sign.url(args, options),
    method: 'post',
})

sign.form = signForm

/**
* @see \App\Http\Controllers\Reimbursements\ReimbursementsController::index
* @see app/Http/Controllers/Reimbursements/ReimbursementsController.php:30
* @route '/{edition}/reimbursements'
*/
export const index = (args: { edition: string | number } | [edition: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: index.url(args, options),
    method: 'get',
})

index.definition = {
    methods: ["get","head"],
    url: '/{edition}/reimbursements',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Reimbursements\ReimbursementsController::index
* @see app/Http/Controllers/Reimbursements/ReimbursementsController.php:30
* @route '/{edition}/reimbursements'
*/
index.url = (args: { edition: string | number } | [edition: string | number ] | string | number, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { edition: args }
    }

    if (Array.isArray(args)) {
        args = {
            edition: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        edition: args.edition,
    }

    return index.definition.url
            .replace('{edition}', parsedArgs.edition.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Reimbursements\ReimbursementsController::index
* @see app/Http/Controllers/Reimbursements/ReimbursementsController.php:30
* @route '/{edition}/reimbursements'
*/
index.get = (args: { edition: string | number } | [edition: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: index.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Reimbursements\ReimbursementsController::index
* @see app/Http/Controllers/Reimbursements/ReimbursementsController.php:30
* @route '/{edition}/reimbursements'
*/
index.head = (args: { edition: string | number } | [edition: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: index.url(args, options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Reimbursements\ReimbursementsController::index
* @see app/Http/Controllers/Reimbursements/ReimbursementsController.php:30
* @route '/{edition}/reimbursements'
*/
const indexForm = (args: { edition: string | number } | [edition: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: index.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Reimbursements\ReimbursementsController::index
* @see app/Http/Controllers/Reimbursements/ReimbursementsController.php:30
* @route '/{edition}/reimbursements'
*/
indexForm.get = (args: { edition: string | number } | [edition: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: index.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Reimbursements\ReimbursementsController::index
* @see app/Http/Controllers/Reimbursements/ReimbursementsController.php:30
* @route '/{edition}/reimbursements'
*/
indexForm.head = (args: { edition: string | number } | [edition: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: index.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

index.form = indexForm

/**
* @see \App\Http\Controllers\Reimbursements\ReimbursementsController::create
* @see app/Http/Controllers/Reimbursements/ReimbursementsController.php:46
* @route '/{edition}/reimbursements'
*/
export const create = (args: { edition: string | number } | [edition: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: create.url(args, options),
    method: 'post',
})

create.definition = {
    methods: ["post"],
    url: '/{edition}/reimbursements',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Reimbursements\ReimbursementsController::create
* @see app/Http/Controllers/Reimbursements/ReimbursementsController.php:46
* @route '/{edition}/reimbursements'
*/
create.url = (args: { edition: string | number } | [edition: string | number ] | string | number, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { edition: args }
    }

    if (Array.isArray(args)) {
        args = {
            edition: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        edition: args.edition,
    }

    return create.definition.url
            .replace('{edition}', parsedArgs.edition.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Reimbursements\ReimbursementsController::create
* @see app/Http/Controllers/Reimbursements/ReimbursementsController.php:46
* @route '/{edition}/reimbursements'
*/
create.post = (args: { edition: string | number } | [edition: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: create.url(args, options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Reimbursements\ReimbursementsController::create
* @see app/Http/Controllers/Reimbursements/ReimbursementsController.php:46
* @route '/{edition}/reimbursements'
*/
const createForm = (args: { edition: string | number } | [edition: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: create.url(args, options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Reimbursements\ReimbursementsController::create
* @see app/Http/Controllers/Reimbursements/ReimbursementsController.php:46
* @route '/{edition}/reimbursements'
*/
createForm.post = (args: { edition: string | number } | [edition: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: create.url(args, options),
    method: 'post',
})

create.form = createForm

/**
* @see \App\Http\Controllers\Reimbursements\ReimbursementsController::show
* @see app/Http/Controllers/Reimbursements/ReimbursementsController.php:72
* @route '/{edition}/reimbursements/{reimbursement}'
*/
export const show = (args: { edition: string | number, reimbursement: number | { id: number } } | [edition: string | number, reimbursement: number | { id: number } ], options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: show.url(args, options),
    method: 'get',
})

show.definition = {
    methods: ["get","head"],
    url: '/{edition}/reimbursements/{reimbursement}',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Reimbursements\ReimbursementsController::show
* @see app/Http/Controllers/Reimbursements/ReimbursementsController.php:72
* @route '/{edition}/reimbursements/{reimbursement}'
*/
show.url = (args: { edition: string | number, reimbursement: number | { id: number } } | [edition: string | number, reimbursement: number | { id: number } ], options?: RouteQueryOptions) => {
    if (Array.isArray(args)) {
        args = {
            edition: args[0],
            reimbursement: args[1],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        edition: args.edition,
        reimbursement: typeof args.reimbursement === 'object'
        ? args.reimbursement.id
        : args.reimbursement,
    }

    return show.definition.url
            .replace('{edition}', parsedArgs.edition.toString())
            .replace('{reimbursement}', parsedArgs.reimbursement.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Reimbursements\ReimbursementsController::show
* @see app/Http/Controllers/Reimbursements/ReimbursementsController.php:72
* @route '/{edition}/reimbursements/{reimbursement}'
*/
show.get = (args: { edition: string | number, reimbursement: number | { id: number } } | [edition: string | number, reimbursement: number | { id: number } ], options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: show.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Reimbursements\ReimbursementsController::show
* @see app/Http/Controllers/Reimbursements/ReimbursementsController.php:72
* @route '/{edition}/reimbursements/{reimbursement}'
*/
show.head = (args: { edition: string | number, reimbursement: number | { id: number } } | [edition: string | number, reimbursement: number | { id: number } ], options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: show.url(args, options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Reimbursements\ReimbursementsController::show
* @see app/Http/Controllers/Reimbursements/ReimbursementsController.php:72
* @route '/{edition}/reimbursements/{reimbursement}'
*/
const showForm = (args: { edition: string | number, reimbursement: number | { id: number } } | [edition: string | number, reimbursement: number | { id: number } ], options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: show.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Reimbursements\ReimbursementsController::show
* @see app/Http/Controllers/Reimbursements/ReimbursementsController.php:72
* @route '/{edition}/reimbursements/{reimbursement}'
*/
showForm.get = (args: { edition: string | number, reimbursement: number | { id: number } } | [edition: string | number, reimbursement: number | { id: number } ], options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: show.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Reimbursements\ReimbursementsController::show
* @see app/Http/Controllers/Reimbursements/ReimbursementsController.php:72
* @route '/{edition}/reimbursements/{reimbursement}'
*/
showForm.head = (args: { edition: string | number, reimbursement: number | { id: number } } | [edition: string | number, reimbursement: number | { id: number } ], options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: show.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

show.form = showForm

/**
* @see \App\Http\Controllers\Reimbursements\ReimbursementsController::print
* @see app/Http/Controllers/Reimbursements/ReimbursementsController.php:203
* @route '/{edition}/reimbursements/{reimbursement}/print'
*/
export const print = (args: { edition: string | number, reimbursement: number | { id: number } } | [edition: string | number, reimbursement: number | { id: number } ], options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: print.url(args, options),
    method: 'get',
})

print.definition = {
    methods: ["get","head"],
    url: '/{edition}/reimbursements/{reimbursement}/print',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Reimbursements\ReimbursementsController::print
* @see app/Http/Controllers/Reimbursements/ReimbursementsController.php:203
* @route '/{edition}/reimbursements/{reimbursement}/print'
*/
print.url = (args: { edition: string | number, reimbursement: number | { id: number } } | [edition: string | number, reimbursement: number | { id: number } ], options?: RouteQueryOptions) => {
    if (Array.isArray(args)) {
        args = {
            edition: args[0],
            reimbursement: args[1],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        edition: args.edition,
        reimbursement: typeof args.reimbursement === 'object'
        ? args.reimbursement.id
        : args.reimbursement,
    }

    return print.definition.url
            .replace('{edition}', parsedArgs.edition.toString())
            .replace('{reimbursement}', parsedArgs.reimbursement.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Reimbursements\ReimbursementsController::print
* @see app/Http/Controllers/Reimbursements/ReimbursementsController.php:203
* @route '/{edition}/reimbursements/{reimbursement}/print'
*/
print.get = (args: { edition: string | number, reimbursement: number | { id: number } } | [edition: string | number, reimbursement: number | { id: number } ], options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: print.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Reimbursements\ReimbursementsController::print
* @see app/Http/Controllers/Reimbursements/ReimbursementsController.php:203
* @route '/{edition}/reimbursements/{reimbursement}/print'
*/
print.head = (args: { edition: string | number, reimbursement: number | { id: number } } | [edition: string | number, reimbursement: number | { id: number } ], options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: print.url(args, options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Reimbursements\ReimbursementsController::print
* @see app/Http/Controllers/Reimbursements/ReimbursementsController.php:203
* @route '/{edition}/reimbursements/{reimbursement}/print'
*/
const printForm = (args: { edition: string | number, reimbursement: number | { id: number } } | [edition: string | number, reimbursement: number | { id: number } ], options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: print.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Reimbursements\ReimbursementsController::print
* @see app/Http/Controllers/Reimbursements/ReimbursementsController.php:203
* @route '/{edition}/reimbursements/{reimbursement}/print'
*/
printForm.get = (args: { edition: string | number, reimbursement: number | { id: number } } | [edition: string | number, reimbursement: number | { id: number } ], options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: print.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Reimbursements\ReimbursementsController::print
* @see app/Http/Controllers/Reimbursements/ReimbursementsController.php:203
* @route '/{edition}/reimbursements/{reimbursement}/print'
*/
printForm.head = (args: { edition: string | number, reimbursement: number | { id: number } } | [edition: string | number, reimbursement: number | { id: number } ], options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: print.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

print.form = printForm

/**
* @see \App\Http\Controllers\Reimbursements\ReimbursementsController::attachment
* @see app/Http/Controllers/Reimbursements/ReimbursementsController.php:227
* @route '/{edition}/reimbursements/{reimbursement}/attachment'
*/
export const attachment = (args: { edition: string | number, reimbursement: number | { id: number } } | [edition: string | number, reimbursement: number | { id: number } ], options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: attachment.url(args, options),
    method: 'get',
})

attachment.definition = {
    methods: ["get","head"],
    url: '/{edition}/reimbursements/{reimbursement}/attachment',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Reimbursements\ReimbursementsController::attachment
* @see app/Http/Controllers/Reimbursements/ReimbursementsController.php:227
* @route '/{edition}/reimbursements/{reimbursement}/attachment'
*/
attachment.url = (args: { edition: string | number, reimbursement: number | { id: number } } | [edition: string | number, reimbursement: number | { id: number } ], options?: RouteQueryOptions) => {
    if (Array.isArray(args)) {
        args = {
            edition: args[0],
            reimbursement: args[1],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        edition: args.edition,
        reimbursement: typeof args.reimbursement === 'object'
        ? args.reimbursement.id
        : args.reimbursement,
    }

    return attachment.definition.url
            .replace('{edition}', parsedArgs.edition.toString())
            .replace('{reimbursement}', parsedArgs.reimbursement.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Reimbursements\ReimbursementsController::attachment
* @see app/Http/Controllers/Reimbursements/ReimbursementsController.php:227
* @route '/{edition}/reimbursements/{reimbursement}/attachment'
*/
attachment.get = (args: { edition: string | number, reimbursement: number | { id: number } } | [edition: string | number, reimbursement: number | { id: number } ], options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: attachment.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Reimbursements\ReimbursementsController::attachment
* @see app/Http/Controllers/Reimbursements/ReimbursementsController.php:227
* @route '/{edition}/reimbursements/{reimbursement}/attachment'
*/
attachment.head = (args: { edition: string | number, reimbursement: number | { id: number } } | [edition: string | number, reimbursement: number | { id: number } ], options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: attachment.url(args, options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Reimbursements\ReimbursementsController::attachment
* @see app/Http/Controllers/Reimbursements/ReimbursementsController.php:227
* @route '/{edition}/reimbursements/{reimbursement}/attachment'
*/
const attachmentForm = (args: { edition: string | number, reimbursement: number | { id: number } } | [edition: string | number, reimbursement: number | { id: number } ], options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: attachment.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Reimbursements\ReimbursementsController::attachment
* @see app/Http/Controllers/Reimbursements/ReimbursementsController.php:227
* @route '/{edition}/reimbursements/{reimbursement}/attachment'
*/
attachmentForm.get = (args: { edition: string | number, reimbursement: number | { id: number } } | [edition: string | number, reimbursement: number | { id: number } ], options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: attachment.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Reimbursements\ReimbursementsController::attachment
* @see app/Http/Controllers/Reimbursements/ReimbursementsController.php:227
* @route '/{edition}/reimbursements/{reimbursement}/attachment'
*/
attachmentForm.head = (args: { edition: string | number, reimbursement: number | { id: number } } | [edition: string | number, reimbursement: number | { id: number } ], options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: attachment.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

attachment.form = attachmentForm

/**
* @see \App\Http\Controllers\Reimbursements\ReimbursementsController::csv
* @see app/Http/Controllers/Reimbursements/ReimbursementsController.php:247
* @route '/{edition}/reimbursements/{reimbursement}/csv'
*/
export const csv = (args: { edition: string | number, reimbursement: number | { id: number } } | [edition: string | number, reimbursement: number | { id: number } ], options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: csv.url(args, options),
    method: 'get',
})

csv.definition = {
    methods: ["get","head"],
    url: '/{edition}/reimbursements/{reimbursement}/csv',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Reimbursements\ReimbursementsController::csv
* @see app/Http/Controllers/Reimbursements/ReimbursementsController.php:247
* @route '/{edition}/reimbursements/{reimbursement}/csv'
*/
csv.url = (args: { edition: string | number, reimbursement: number | { id: number } } | [edition: string | number, reimbursement: number | { id: number } ], options?: RouteQueryOptions) => {
    if (Array.isArray(args)) {
        args = {
            edition: args[0],
            reimbursement: args[1],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        edition: args.edition,
        reimbursement: typeof args.reimbursement === 'object'
        ? args.reimbursement.id
        : args.reimbursement,
    }

    return csv.definition.url
            .replace('{edition}', parsedArgs.edition.toString())
            .replace('{reimbursement}', parsedArgs.reimbursement.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Reimbursements\ReimbursementsController::csv
* @see app/Http/Controllers/Reimbursements/ReimbursementsController.php:247
* @route '/{edition}/reimbursements/{reimbursement}/csv'
*/
csv.get = (args: { edition: string | number, reimbursement: number | { id: number } } | [edition: string | number, reimbursement: number | { id: number } ], options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: csv.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Reimbursements\ReimbursementsController::csv
* @see app/Http/Controllers/Reimbursements/ReimbursementsController.php:247
* @route '/{edition}/reimbursements/{reimbursement}/csv'
*/
csv.head = (args: { edition: string | number, reimbursement: number | { id: number } } | [edition: string | number, reimbursement: number | { id: number } ], options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: csv.url(args, options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Reimbursements\ReimbursementsController::csv
* @see app/Http/Controllers/Reimbursements/ReimbursementsController.php:247
* @route '/{edition}/reimbursements/{reimbursement}/csv'
*/
const csvForm = (args: { edition: string | number, reimbursement: number | { id: number } } | [edition: string | number, reimbursement: number | { id: number } ], options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: csv.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Reimbursements\ReimbursementsController::csv
* @see app/Http/Controllers/Reimbursements/ReimbursementsController.php:247
* @route '/{edition}/reimbursements/{reimbursement}/csv'
*/
csvForm.get = (args: { edition: string | number, reimbursement: number | { id: number } } | [edition: string | number, reimbursement: number | { id: number } ], options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: csv.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Reimbursements\ReimbursementsController::csv
* @see app/Http/Controllers/Reimbursements/ReimbursementsController.php:247
* @route '/{edition}/reimbursements/{reimbursement}/csv'
*/
csvForm.head = (args: { edition: string | number, reimbursement: number | { id: number } } | [edition: string | number, reimbursement: number | { id: number } ], options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: csv.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

csv.form = csvForm

/**
* @see \App\Http\Controllers\Reimbursements\ReimbursementsController::update
* @see app/Http/Controllers/Reimbursements/ReimbursementsController.php:122
* @route '/{edition}/reimbursements/{reimbursement}'
*/
export const update = (args: { edition: string | number, reimbursement: number | { id: number } } | [edition: string | number, reimbursement: number | { id: number } ], options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: update.url(args, options),
    method: 'post',
})

update.definition = {
    methods: ["post"],
    url: '/{edition}/reimbursements/{reimbursement}',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Reimbursements\ReimbursementsController::update
* @see app/Http/Controllers/Reimbursements/ReimbursementsController.php:122
* @route '/{edition}/reimbursements/{reimbursement}'
*/
update.url = (args: { edition: string | number, reimbursement: number | { id: number } } | [edition: string | number, reimbursement: number | { id: number } ], options?: RouteQueryOptions) => {
    if (Array.isArray(args)) {
        args = {
            edition: args[0],
            reimbursement: args[1],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        edition: args.edition,
        reimbursement: typeof args.reimbursement === 'object'
        ? args.reimbursement.id
        : args.reimbursement,
    }

    return update.definition.url
            .replace('{edition}', parsedArgs.edition.toString())
            .replace('{reimbursement}', parsedArgs.reimbursement.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Reimbursements\ReimbursementsController::update
* @see app/Http/Controllers/Reimbursements/ReimbursementsController.php:122
* @route '/{edition}/reimbursements/{reimbursement}'
*/
update.post = (args: { edition: string | number, reimbursement: number | { id: number } } | [edition: string | number, reimbursement: number | { id: number } ], options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: update.url(args, options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Reimbursements\ReimbursementsController::update
* @see app/Http/Controllers/Reimbursements/ReimbursementsController.php:122
* @route '/{edition}/reimbursements/{reimbursement}'
*/
const updateForm = (args: { edition: string | number, reimbursement: number | { id: number } } | [edition: string | number, reimbursement: number | { id: number } ], options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: update.url(args, options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Reimbursements\ReimbursementsController::update
* @see app/Http/Controllers/Reimbursements/ReimbursementsController.php:122
* @route '/{edition}/reimbursements/{reimbursement}'
*/
updateForm.post = (args: { edition: string | number, reimbursement: number | { id: number } } | [edition: string | number, reimbursement: number | { id: number } ], options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: update.url(args, options),
    method: 'post',
})

update.form = updateForm

/**
* @see \App\Http\Controllers\Reimbursements\ReimbursementsController::deleteMethod
* @see app/Http/Controllers/Reimbursements/ReimbursementsController.php:189
* @route '/{edition}/reimbursements/{reimbursement}'
*/
export const deleteMethod = (args: { edition: string | number, reimbursement: number | { id: number } } | [edition: string | number, reimbursement: number | { id: number } ], options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: deleteMethod.url(args, options),
    method: 'delete',
})

deleteMethod.definition = {
    methods: ["delete"],
    url: '/{edition}/reimbursements/{reimbursement}',
} satisfies RouteDefinition<["delete"]>

/**
* @see \App\Http\Controllers\Reimbursements\ReimbursementsController::deleteMethod
* @see app/Http/Controllers/Reimbursements/ReimbursementsController.php:189
* @route '/{edition}/reimbursements/{reimbursement}'
*/
deleteMethod.url = (args: { edition: string | number, reimbursement: number | { id: number } } | [edition: string | number, reimbursement: number | { id: number } ], options?: RouteQueryOptions) => {
    if (Array.isArray(args)) {
        args = {
            edition: args[0],
            reimbursement: args[1],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        edition: args.edition,
        reimbursement: typeof args.reimbursement === 'object'
        ? args.reimbursement.id
        : args.reimbursement,
    }

    return deleteMethod.definition.url
            .replace('{edition}', parsedArgs.edition.toString())
            .replace('{reimbursement}', parsedArgs.reimbursement.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Reimbursements\ReimbursementsController::deleteMethod
* @see app/Http/Controllers/Reimbursements/ReimbursementsController.php:189
* @route '/{edition}/reimbursements/{reimbursement}'
*/
deleteMethod.delete = (args: { edition: string | number, reimbursement: number | { id: number } } | [edition: string | number, reimbursement: number | { id: number } ], options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: deleteMethod.url(args, options),
    method: 'delete',
})

/**
* @see \App\Http\Controllers\Reimbursements\ReimbursementsController::deleteMethod
* @see app/Http/Controllers/Reimbursements/ReimbursementsController.php:189
* @route '/{edition}/reimbursements/{reimbursement}'
*/
const deleteMethodForm = (args: { edition: string | number, reimbursement: number | { id: number } } | [edition: string | number, reimbursement: number | { id: number } ], options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: deleteMethod.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'DELETE',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Reimbursements\ReimbursementsController::deleteMethod
* @see app/Http/Controllers/Reimbursements/ReimbursementsController.php:189
* @route '/{edition}/reimbursements/{reimbursement}'
*/
deleteMethodForm.delete = (args: { edition: string | number, reimbursement: number | { id: number } } | [edition: string | number, reimbursement: number | { id: number } ], options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: deleteMethod.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'DELETE',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

deleteMethod.form = deleteMethodForm

const ReimbursementsController = { sign, index, create, show, print, attachment, csv, update, deleteMethod, delete: deleteMethod }

export default ReimbursementsController